import script from "./ComercialChart2.vue?vue&type=script&setup=true&lang=js"
export * from "./ComercialChart2.vue?vue&type=script&setup=true&lang=js"

import "./ComercialChart2.vue?vue&type=style&index=0&id=d1a4b9d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a4b9d6"]])

export default __exports__